<template>
  <div class="flex" style="height: 100%">
    <div id="realtime-left" class="left">
      <a-row style="width: 100%" class="t-head">
        <a-col :span="12" class="label">参数名称</a-col>
        <a-col :span="12" class="label">值</a-col>
      </a-row>
      <div class="t-body">
        <ml-virtual-scroller :items="propertyItems" :itemSize="32" @scrollIndexChange="onScrollIndexChange" @scroll="onScroll" ref="dataVirtualScroller">
          <template v-slot:item="{ item, options }">
            <a-row
              class="row"
              :class="{
                'row-odd': options.index % 2,
                'row-even': !(options.index % 2),
              }"
            >
              <a-col :span="12" class="col">{{ item.paramDesc }}</a-col>
              <a-col :span="12" class="col">{{ item.paramValue }}</a-col>
            </a-row>
          </template>
        </ml-virtual-scroller>
      </div>
      <!--
      <ml-table
        :columns="columns"
        :dataSource="propertyItems"
      ></ml-table>
      -->
      <!-- :scroll="{ y: propScrollY }" -->
    </div>
    <div id="realtime-right" class="right">
      <ml-table :columns="columnsAlarm" :dataSource="alertList"></ml-table>
    </div>
  </div>
</template>

<script>
import { getUserInfo } from '@/utils/auth'
import { getToken } from '@/utils/auth' // get token from cookie
import dayjs from 'dayjs'
import * as _ from 'lodash'

import { AlarmStatisticsServiceProxy } from '@/service-proxies/app-v2/mdc.service-proxies'
import { WorkStationWorkingConditionParamSettingServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'

const wswcpssp = new WorkStationWorkingConditionParamSettingServiceProxy()
const assp = new AlarmStatisticsServiceProxy()

let websock
export default {
  props: {
    device: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      propScrollY: 0,
      alertScrollY: 0,
      propertyItems: [],
      alertList: [],
      columnsAlarm: [
        {
          title: this.$t('page_alarm_alarmmsg'),
          dataIndex: 'alarmCode',
          key: 'alarmCode',
          ellipsis: true,
          customRender: (text, record) => {
            return (
              <a-tooltip>
                <template slot='title'>{record.alarmMsg}</template>
                <a-tag color='green'>{text}</a-tag>
                {record.alarmMsg}
              </a-tooltip>
            )
          },
        },
        {
          title: this.$t('page_ops_customer_alarm_time'),
          dataIndex: 'alarmTime',
          key: 'alarmTime',
          ellipsis: true,
        },
      ],
      columns: [
        {
          title: this.$t('page_ops_customer_parameter_name'),
          dataIndex: 'paramDesc',
          key: 'paramDesc',
          ellipsis: true,
        },
        {
          title: this.$t('page_ops_customer_real_time_value'),
          dataIndex: 'paramValue',
          key: 'paramValue',
          ellipsis: true,
        },
      ],
      iotPaths: [],
      subTopicList: [],
    }
  },
  watch: {
    device: {
      handler(val) {
        this.alertList = []
        this.propertyItems = []
        if (!val.id) {
          return
        }
        this.closeWebsock()
        setTimeout(() => {
          this.initWebSocket([this.device.id])
          this.getProperties()
        }, 1000)

        this.getAlarm()
      },
      deep: true,
      immediate: true,
    },
  },
  beforeDestroy() {
    this.closeWebsock()
  },
  mounted() {
    if (this.device.id) {
      // this.getProperties()
      // this.initWebSocket([this.device.id])
      this.getAlarm()
    }
  },
  methods: {
    getTenantId() {
      const info = getUserInfo()
      return info.tenant_id || ''
    },
    closeWebsock() {
      websock && websock.close()
      websock = null
    },
    /*
    checkScroll() {
      this.propScrollY = 0
      this.alertScrollY = 0
      const devLeft = document.getElementById('realtime-left')
      const devRight = document.getElementById('realtime-right')
      if (
        this.propertyItems &&
        devLeft.clientHeight &&
        this.propertyItems.length * 31 > devLeft.clientHeight
      ) {
        this.propScrollY = devLeft.clientHeight - 35
      }
      if (
        this.alertList &&
        devLeft.clientHeight &&
        this.alertList.length * 31 > devLeft.clientHeight
      ) {
        this.alertScrollY = devRight.clientHeight - 35
      }
    },
    */
    async getProperties() {
      if (!this.device || !this.device.id) {
        return
      }
      const data = await wswcpssp.getWorkingConditionParams(this.device.id)
      if (data && data.length) {
        this.propertyItems = data.map((res) => {
          const value = { ...res }
          value.paramValue = ''
          return value
        })
      }
      const tenantId = this.getTenantId()
      if (data && data.length) {
        this.iotPaths = data.map((item) => {
          return `${tenantId}/${item.iotId}/${item.iotAppId}/${item.iotAppParamDesc}`
        })
        this.refreshRealData()
      }
      /*
      if (this.iotPaths.length > 0) {
        const mesg = {
          command: 'SUBSCRIBE',
          data: Array.from(new Set(this.iotPaths)),
          context: String(Date.now())
        }
        let flag = false
        setInterval(() => {
          if(websock && websock.readyState === 1 && !flag) {
            websock && websock.send(JSON.stringify(mesg))
            flag = true
          }
        }, 1000)
      }
      */
    },
    changeReafh(data) {
      const tenantId = this.getTenantId()
      const newData = [...this.propertyItems]
      const target = newData.find((item) => `${tenantId}/${item.iotId}/${item.iotAppId}/${item.iotAppParamDesc}` === data.topic)
      if (target) {
        target.paramValue = data.data.propertyValue
        this.propertyItems = newData
      }
    },
    initWebSocket(ids) {
      const wsuri = REALTIME_WEBSOCKET_URL + '/' + getToken()
      // if (!websock) {
      websock = new WebSocket(wsuri)
      // } else {
      //   if (websock.readyState === 1) {
      //     websock.send(JSON.stringify({ code: 'unsubscribe', messageType: 1001 }))
      //     const open = {
      //       code: 'subscribe',
      //       ids,
      //       messageType: 1001
      //    }
      //    websock.send(JSON.stringify(open))
      //   }
      // }
      websock.onmessage = (e) => {
        const data = JSON.parse(e.data)
        if (data.command !== 'DATA') {
          return
        }
        this.changeReafh(data)
      }
      websock.onclose = (e) => {
        websock = null
      }
      websock.onerror = () => {
        this.refreshRealData()
      }
      websock.onopen = () => {
        this.refreshRealData()
      }
    },
    getAlarm() {
      this.alertList = []
      assp.alarmRealDetail(0, 500, this.device.id).then((res) => {
        if (res.records && res.records.length) {
          this.alertList = res.records
          this.alertList.map((item) => {
            item.alarmTime = item.alarmTime ? dayjs(item.alarmTime).format('YYYY-MM-DD HH:mm:ss') : ''
          })
          this.checkScroll()
        }
      })
    },
    onScrollIndexChange(e) {},
    onScroll: _.debounce(function () {
      this.refreshRealData()
    }, 500),
    refreshRealData() {
      const range = this.$refs.dataVirtualScroller.getRenderedRange()
      this.unSubTopic()
      this.subTopic(range.viewport.first, range.viewport.last)
    },
    unSubTopic() {
      if (this.subTopicList && this.subTopicList.length) {
        const mesg = {
          command: 'UNSUBSCRIBE',
          data: Array.from(new Set(this.subTopicList)),
          context: String(Date.now()),
        }
        websock.send(JSON.stringify(mesg))
      }
    },
    subTopic(first, last) {
      const sub = this.iotPaths.slice(first, last)
      this.subTopicList = [...sub]
      const mesg = {
        command: 'SUBSCRIBE',
        data: Array.from(new Set(this.subTopicList)),
        context: String(Date.now()),
      }
      console.log(111, mesg)
      websock.send(JSON.stringify(mesg))
    },
  },
}
</script>

<style scoped lang="less">
.flex {
  display: flex;
}

.t-head {
  height: 32px;
  width: 100%;
  background-color: #d8edff;

  .label {
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
    text-align: left;
    padding: 5px 8px;
  }
}

.t-body {
  height: calc(100% - 32px);
  overflow-y: auto;

  .row {
    width: 100%;
    border: 1px solid #e8e8e8;
  }

  .row-odd {
    background-color: #f8f8f8;
  }

  .row-even {
    background-color: #fff;
  }

  .col {
    border-right: 1px solid #e8e8e8;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    word-break: break-all;
    padding: 4px;
  }
}

.value {
  margin-top: 1vh;
}

.left {
  height: calc(100% - 35px);
  flex: 1;
  width: 50%;
  // overflow: auto;
}

.right {
  width: 47%;
  display: inline-block;
  margin-left: 3%;
  flex: 1;
  height: calc(100% - 35px);
  overflow: auto;
}

.machine-status {
  height: 11vh;
  width: 100%;

  .time-chart {
    width: 100%;
    height: 9vh;
  }
}

.params-list {
  width: 100%;
  //height: 24vh;
  height: calc(~'100% - 11vh');
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  overflow: auto;

  label {
    display: inline-block;
    width: 30%;
  }
}

.params-category {
  width: 100%;
  display: flex;
  justify-content: space-between;

  ul {
    width: 48%;

    .title {
      margin-bottom: 10px;
    }

    li {
      padding-left: 1.5vw;
      margin-bottom: 1vh;

      span {
        padding-left: 1vw;
        width: 50%;
        display: inline-block;
      }
    }
  }
}

.params-item {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  li {
    width: 48%;
    color: #444;
    margin-top: 2vh;
    list-style: none;

    .label {
      width: 40%;
      color: rgba(0, 0, 0, 0.85);
    }

    span {
      padding-left: 2%;
      width: 52%;
      display: inline-block;
      color: rgba(0, 0, 0, 0.65);
    }
  }

  @media screen and (max-width: 1500px) {
    li {
      width: 100%;
    }
  }
}

.alert-list {
  margin-top: 2vh;
  /*height: calc(~' 100% - 4vh');*/
  height: calc(100% - 2vh - 21px);
  overflow: auto;

  li {
    height: 3vh;
    line-height: 3vh;
    padding: 0 10px;
    display: flow-root;

    &:nth-child(odd) {
      background-color: rgba(255, 255, 255, 0.1);
    }

    .ivu-tooltip {
      width: 100%;
    }

    .code {
      float: left;
      color: #ef7e7e;
      max-width: 30%;
    }

    .time {
      float: right;
      max-width: 70%;
    }
  }
}
</style>
